import { postRequest } from 'utils/requests';
import { AssociationOutcome } from './types';
import {
  parseAcceptedResponse,
  parseAssociationError
} from './parseAssociationResponse';

// MAPI Phase 2 is asynchronous: 202 Accepted carries a validation-only
// breakdown - which tenants will migrate and which were skipped and why -
// while the per-tenant migration outcomes land in MsspMigrationTracking and
// in the Datadog log stream, not in the HTTP response. Both 400 shapes carry
// the same detail, so success and failure are normalised the same way and the
// caller gets one outcome to switch on.
const ENDPOINT = '/customer/cp/msp-children/association';

export const postMspChildrenAssociation = async (
  payload: unknown
): Promise<AssociationOutcome> => {
  try {
    return parseAcceptedResponse(await postRequest(ENDPOINT, payload));
  } catch (err) {
    return parseAssociationError(err);
  }
};
